var router = require('pjax').Router;
var index = require('./index.js');

router.get('content/interface', index);
